// Port of api/fuel/app/classes/filter/package/games/collection.php
import RenamesData from 'offline/filter/package/games/collection/data/renames'
import DatesPrepare from 'offline/filter/package/games/collection/prepare/dates'
import InventoryPrepare from 'offline/filter/package/games/collection/prepare/inventory'
import NestingPrepare from 'offline/filter/package/games/collection/prepare/nesting'
import RenamesPrepare from 'offline/filter/package/games/collection/prepare/renames'
import NestingPackage from 'offline/filter/package/games/collection/package/nesting'

function sortUnits(units) {
	return units.slice().sort(function(a, b) {
		return (a.priority || 0) - (b.priority || 0)
	})
}

function runPrepare(units, local, global, config, filter) {
	var prepared = Object.assign({}, local)
	var sorted = sortUnits(units)

	for (var i = 0; i < sorted.length; i++) {
		var unit = sorted[i]
		if (unit.require && !unit.require(config, filter, null, global)) continue
		var result = unit.run(prepared, global, config, filter)
		if (result !== undefined) prepared = result
	}

	return prepared
}

function runPackage(units, prepared, global, config, filter) {
	var pkg = {}
	var sorted = sortUnits(units)

	for (var i = 0; i < sorted.length; i++) {
		var unit = sorted[i]
		if (unit.require && !unit.require(config, filter, null, global)) continue
		var result = unit.run(pkg, prepared, global, config, filter)
		if (result !== undefined) pkg = result
	}

	return pkg
}

export default {
	data_units: [RenamesData],
	prepare_units: [DatesPrepare, InventoryPrepare, NestingPrepare, RenamesPrepare],
	package_units: [NestingPackage],

	run: function(resultId, local, global, config, filter) {
		var prepared = runPrepare(this.prepare_units, local, global, config, filter)
		var pkg = runPackage(this.package_units, prepared, global, config, filter)
		pkg.id = resultId
		return pkg
	}
}
